$('[data-scrollto]').on('click focus', function(e) {
	e.preventDefault();
	var target = typeof $(this).attr('href') !== 'undefined' ? $(this).attr('href') : $(this).data('scrollto');

	$('html, body').animate({
		scrollTop: $(target).offset().top
	}, 600);
});